"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_DATA_INCLUDE_ARCHIVED_UPDATED = exports.EVENT_DATA_EDIT_ERROR = exports.EVENT_DATA_EDIT_SUCCESS = exports.EVENT_DATA_EDIT_REQUESTED = exports.EVENT_DATA_ADD_ERROR = exports.EVENT_DATA_ADD_SUCCESS = exports.EVENT_DATA_ADD_REQUESTED = exports.EVENT_DATA_ERROR = exports.EVENT_DATA_SUCCESS = exports.EVENT_DATA_REQUESTED = void 0;
// Events API - Event Data Entity
var EVENT_DATA_REQUESTED = 'EVENT_DATA_REQUESTED';
exports.EVENT_DATA_REQUESTED = EVENT_DATA_REQUESTED;
var EVENT_DATA_SUCCESS = 'EVENT_DATA_SUCCESS';
exports.EVENT_DATA_SUCCESS = EVENT_DATA_SUCCESS;
var EVENT_DATA_ERROR = 'EVENT_DATA_ERROR';
exports.EVENT_DATA_ERROR = EVENT_DATA_ERROR;
var EVENT_DATA_ADD_REQUESTED = 'EVENT_DATA_ADD_REQUESTED';
exports.EVENT_DATA_ADD_REQUESTED = EVENT_DATA_ADD_REQUESTED;
var EVENT_DATA_ADD_SUCCESS = 'EVENT_DATA_ADD_SUCCESS';
exports.EVENT_DATA_ADD_SUCCESS = EVENT_DATA_ADD_SUCCESS;
var EVENT_DATA_ADD_ERROR = 'EVENT_DATA_ADD_ERROR';
exports.EVENT_DATA_ADD_ERROR = EVENT_DATA_ADD_ERROR;
var EVENT_DATA_EDIT_REQUESTED = 'EVENT_DATA_EDIT_REQUESTED';
exports.EVENT_DATA_EDIT_REQUESTED = EVENT_DATA_EDIT_REQUESTED;
var EVENT_DATA_EDIT_SUCCESS = 'EVENT_DATA_EDIT_SUCCESS';
exports.EVENT_DATA_EDIT_SUCCESS = EVENT_DATA_EDIT_SUCCESS;
var EVENT_DATA_EDIT_ERROR = 'EVENT_DATA_EDIT_ERROR';
exports.EVENT_DATA_EDIT_ERROR = EVENT_DATA_EDIT_ERROR;
var EVENT_DATA_INCLUDE_ARCHIVED_UPDATED = 'EVENT_DATA_INCLUDE_ARCHIVED_UPDATED';
exports.EVENT_DATA_INCLUDE_ARCHIVED_UPDATED = EVENT_DATA_INCLUDE_ARCHIVED_UPDATED;